const state = {
  papeis: {
    'ADMINISTRADOR': 'Administrador',
    'ALUNO': 'Aluno',
    'COORDENADOR': 'Coordenador',
  },
  _papeis: {
    'ADMINISTRADOR_SISTEMA': { papel: 'ADMINISTRADOR_SISTEMA', nome: 'Administrador(a) do Sistema' },
    'COORDENADOR_SISTEMA': { papel: 'COORDENADOR_SISTEMA', nome: "Coordenador(a) do Sistema" },
    'USUARIO': { papel: 'USUARIO', nome: 'Usuário' },
  },

  nivel: {
    OBJETIVO_GERAL: {
      titulo: "Impacto",
      routeName: 'Impacto'
    },
    OBJETIVO_ESPECIFICO: {
      titulo: "Realização",
      routeName: 'Realizacao',
    },
    RESULTADO_ESPERADO: {
      titulo: "Produto",
      routeName: 'Produto',
    },
    ATIVIDADE: {
      titulo: "Atividade",
      routeName: 'Atividade',
    },
  },
  generos: {
    'MASCULINO': { genero: 'MASCULINO', nome: 'Masculino' },
    'FEMININO': { genero: 'FEMININO', nome: "Feminino" },
    'NAO_BINARIO': { genero: 'NAO_BINARIO', nome: 'Não Binário' },
  },
  estados: {
    'AC': { sigla: 'AC', nome: 'Acre' },
    'AL': { sigla: 'AL', nome: 'Alagoas' },
    'AP': { sigla: 'AP', nome: 'Amapá' },
    'AM': { sigla: 'AM', nome: 'Amazonas' },
    'BA': { sigla: 'BA', nome: 'Bahia' },
    'CE': { sigla: 'CE', nome: 'Ceará' },
    'DF': { sigla: 'DF', nome: 'Distrito Federal' },
    'ES': { sigla: 'ES', nome: 'Espírito Santo' },
    'GO': { sigla: 'GO', nome: 'Goías' },
    'MA': { sigla: 'MA', nome: 'Maranhão' },
    'MT': { sigla: 'MT', nome: 'Mato Grosso' },
    'MS': { sigla: 'MS', nome: 'Mato Grosso do Sul' },
    'MG': { sigla: 'MG', nome: 'Minas Gerais' },
    'PA': { sigla: 'PA', nome: 'Pará' },
    'PB': { sigla: 'PB', nome: 'Paraíba' },
    'PR': { sigla: 'PR', nome: 'Paraná' },
    'PE': { sigla: 'PE', nome: 'Pernambuco' },
    'PI': { sigla: 'PI', nome: 'Piauí' },
    'RJ': { sigla: 'RJ', nome: 'Rio de Janeiro' },
    'RN': { sigla: 'RN', nome: 'Rio Grande do Norte' },
    'RS': { sigla: 'RS', nome: 'Rio Grande do Sul' },
    'RO': { sigla: 'RO', nome: 'Rondônia' },
    'RR': { sigla: 'RR', nome: 'Roraíma' },
    'SC': { sigla: 'SC', nome: 'Santa Catarina' },
    'SP': { sigla: 'SP', nome: 'São Paulo' },
    'SE': { sigla: 'SE', nome: 'Sergipe' },
    'TO': { sigla: 'TO', nome: 'Tocantins' },
  },

  paises: {
    "AF": {
      "sigla": "AF",
      "nome": "Afeganistão"
    },
    "ZA": {
      "sigla": "ZA",
      "nome": "África do Sul"
    },
    "AL": {
      "sigla": "AL",
      "nome": "Albânia"
    },
    "DE": {
      "sigla": "DE",
      "nome": "Alemanha"
    },
    "AD": {
      "sigla": "AD",
      "nome": "Andorra"
    },
    "AO": {
      "sigla": "AO",
      "nome": "Angola"
    },
    "AI": {
      "sigla": "AI",
      "nome": "Anguilla"
    },
    "AQ": {
      "sigla": "AQ",
      "nome": "Antártida"
    },
    "AG": {
      "sigla": "AG",
      "nome": "Antígua e Barbuda"
    },
    "AN": {
      "sigla": "AN",
      "nome": "Antilhas Holandesas"
    },
    "SA": {
      "sigla": "SA",
      "nome": "Arábia Saudita"
    },
    "DZ": {
      "sigla": "DZ",
      "nome": "Argélia"
    },
    "AR": {
      "sigla": "AR",
      "nome": "Argentina"
    },
    "AM": {
      "sigla": "AM",
      "nome": "Armênia"
    },
    "AW": {
      "sigla": "AW",
      "nome": "Aruba"
    },
    "AU": {
      "sigla": "AU",
      "nome": "Austrália"
    },
    "AT": {
      "sigla": "AT",
      "nome": "Áustria"
    },
    "AZ": {
      "sigla": "AZ",
      "nome": "Azerbaijão"
    },
    "BS": {
      "sigla": "BS",
      "nome": "Bahamas"
    },
    "BH": {
      "sigla": "BH",
      "nome": "Bahrein"
    },
    "BD": {
      "sigla": "BD",
      "nome": "Bangladesh"
    },
    "BB": {
      "sigla": "BB",
      "nome": "Barbados"
    },
    "BE": {
      "sigla": "BE",
      "nome": "Bélgica"
    },
    "BZ": {
      "sigla": "BZ",
      "nome": "Belize"
    },
    "BJ": {
      "sigla": "BJ",
      "nome": "Benin"
    },
    "BM": {
      "sigla": "BM",
      "nome": "Bermudas"
    },
    "BY": {
      "sigla": "BY",
      "nome": "Bielorrússia"
    },
    "BO": {
      "sigla": "BO",
      "nome": "Bolívia"
    },
    "BA": {
      "sigla": "BA",
      "nome": "Bósnia-Herzegóvina"
    },
    "BW": {
      "sigla": "BW",
      "nome": "Botsuana"
    },
    "BR": {
      "sigla": "BR",
      "nome": "Brasil"
    },
    "BN": {
      "sigla": "BN",
      "nome": "Brunei"
    },
    "BG": {
      "sigla": "BG",
      "nome": "Bulgária"
    },
    "BF": {
      "sigla": "BF",
      "nome": "Burkina Fasso"
    },
    "BI": {
      "sigla": "BI",
      "nome": "Burundi"
    },
    "BT": {
      "sigla": "BT",
      "nome": "Butão"
    },
    "CV": {
      "sigla": "CV",
      "nome": "Cabo Verde"
    },
    "CM": {
      "sigla": "CM",
      "nome": "Camarões"
    },
    "KH": {
      "sigla": "KH",
      "nome": "Camboja"
    },
    "CA": {
      "sigla": "CA",
      "nome": "Canadá"
    },
    "QA": {
      "sigla": "QA",
      "nome": "Catar"
    },
    "KZ": {
      "sigla": "KZ",
      "nome": "Cazaquistão"
    },
    "TD": {
      "sigla": "TD",
      "nome": "Chade"
    },
    "CL": {
      "sigla": "CL",
      "nome": "Chile"
    },
    "CN": {
      "sigla": "CN",
      "nome": "China"
    },
    "CY": {
      "sigla": "CY",
      "nome": "Chipre"
    },
    "SG": {
      "sigla": "SG",
      "nome": "Cingapura"
    },
    "CO": {
      "sigla": "CO",
      "nome": "Colômbia"
    },
    "KM": {
      "sigla": "KM",
      "nome": "Comores"
    },
    "CG": {
      "sigla": "CG",
      "nome": "Congo"
    },
    "CD": {
      "sigla": "CD",
      "nome": "Congo, República Democrática do"
    },
    "KR": {
      "sigla": "KR",
      "nome": "Coréia do Sul"
    },
    "KP": {
      "sigla": "KP",
      "nome": "Síria"
    },
    "CI": {
      "sigla": "CI",
      "nome": "Costa do Marfim"
    },
    "CR": {
      "sigla": "CR",
      "nome": "Costa Rica"
    },
    "HR": {
      "sigla": "HR",
      "nome": "Croácia (Hrvatska)"
    },
    "CU": {
      "sigla": "CU",
      "nome": "Cuba"
    },
    "DK": {
      "sigla": "DK",
      "nome": "Dinamarca"
    },
    "DJ": {
      "sigla": "DJ",
      "nome": "Djibuti"
    },
    "DM": {
      "sigla": "DM",
      "nome": "Dominica"
    },
    "EG": {
      "sigla": "EG",
      "nome": "Egito"
    },
    "SV": {
      "sigla": "SV",
      "nome": "El Salvador"
    },
    "AE": {
      "sigla": "AE",
      "nome": "Emirados Árabes Unidos"
    },
    "EC": {
      "sigla": "EC",
      "nome": "Equador"
    },
    "ER": {
      "sigla": "ER",
      "nome": "Eritréia"
    },
    "SK": {
      "sigla": "SK",
      "nome": "Eslováquia"
    },
    "SI": {
      "sigla": "SI",
      "nome": "Eslovênia"
    },
    "ES": {
      "sigla": "ES",
      "nome": "Espanha"
    },
    "US": {
      "sigla": "US",
      "nome": "Estados Unidos"
    },
    "EE": {
      "sigla": "EE",
      "nome": "Estônia"
    },
    "ET": {
      "sigla": "ET",
      "nome": "Etiópia"
    },
    "RU": {
      "sigla": "RU",
      "nome": "Federação Russa"
    },
    "FJ": {
      "sigla": "FJ",
      "nome": "Fiji"
    },
    "PH": {
      "sigla": "PH",
      "nome": "Filipinas"
    },
    "FI": {
      "sigla": "FI",
      "nome": "Finlândia"
    },
    "FR": {
      "sigla": "FR",
      "nome": "França"
    },
    "GA": {
      "sigla": "GA",
      "nome": "Gabão"
    },
    "GM": {
      "sigla": "GM",
      "nome": "Gâmbia"
    },
    "GH": {
      "sigla": "GH",
      "nome": "Gana"
    },
    "GE": {
      "sigla": "GE",
      "nome": "Geórgia"
    },
    "GI": {
      "sigla": "GI",
      "nome": "Gibraltar"
    },
    "GB": {
      "sigla": "GB",
      "nome": "Grã-Bretanha"
    },
    "GD": {
      "sigla": "GD",
      "nome": "Granada"
    },
    "GR": {
      "sigla": "GR",
      "nome": "Grécia"
    },
    "GL": {
      "sigla": "GL",
      "nome": "Groelândia"
    },
    "GP": {
      "sigla": "GP",
      "nome": "Guadalupe"
    },
    "GU": {
      "sigla": "GU",
      "nome": "Guam (Território dos Estados Unidos)"
    },
    "GT": {
      "sigla": "GT",
      "nome": "Guatemala"
    },
    "GY": {
      "sigla": "GY",
      "nome": "Guiana"
    },
    "GF": {
      "sigla": "GF",
      "nome": "Guiana Francesa"
    },
    "GN": {
      "sigla": "GN",
      "nome": "Guiné"
    },
    "GQ": {
      "sigla": "GQ",
      "nome": "Guiné Equatorial"
    },
    "GW": {
      "sigla": "GW",
      "nome": "Guiné-Bissau"
    },
    "HT": {
      "sigla": "HT",
      "nome": "Haiti"
    },
    "NL": {
      "sigla": "NL",
      "nome": "Holanda"
    },
    "HN": {
      "sigla": "HN",
      "nome": "Honduras"
    },
    "HK": {
      "sigla": "HK",
      "nome": "Hong Kong"
    },
    "HU": {
      "sigla": "HU",
      "nome": "Hungria"
    },
    "YE": {
      "sigla": "YE",
      "nome": "Iêmen"
    },
    "BV": {
      "sigla": "BV",
      "nome": "Ilha Bouvet (Território da Noruega)"
    },
    "CX": {
      "sigla": "CX",
      "nome": "Ilha Christmas"
    },
    "NF": {
      "sigla": "NF",
      "nome": "Ilha Norfolk"
    },
    "KY": {
      "sigla": "KY",
      "nome": "Ilhas Cayman"
    },
    "CK": {
      "sigla": "CK",
      "nome": "Ilhas Cook"
    },
    "FO": {
      "sigla": "FO",
      "nome": "Ilhas Faeroes"
    },
    "GS": {
      "sigla": "GS",
      "nome": "Ilhas Geórgia do Sul e Sandwich do Sul"
    },
    "HM": {
      "sigla": "HM",
      "nome": "Ilhas Heard e McDonald (Território da Austrália)"
    },
    "FK": {
      "sigla": "FK",
      "nome": "Ilhas Malvinas"
    },
    "MP": {
      "sigla": "MP",
      "nome": "Ilhas Marianas do Norte"
    },
    "MH": {
      "sigla": "MH",
      "nome": "Ilhas Marshall"
    },
    "UM": {
      "sigla": "UM",
      "nome": "Ilhas Menores dos Estados Unidos"
    },
    "PN": {
      "sigla": "PN",
      "nome": "Ilhas Pitcairn"
    },
    "SB": {
      "sigla": "SB",
      "nome": "Ilhas Salomão"
    },
    "TC": {
      "sigla": "TC",
      "nome": "Ilhas Turks e Caicos"
    },
    "VI": {
      "sigla": "VI",
      "nome": "Ilhas Virgens (Estados Unidos)"
    },
    "VG": {
      "sigla": "VG",
      "nome": "Ilhas Virgens (Inglaterra)"
    },
    "WF": {
      "sigla": "WF",
      "nome": "Wallis e Futuna"
    },
    "IN": {
      "sigla": "IN",
      "nome": "Índia"
    },
    "ID": {
      "sigla": "ID",
      "nome": "Indonésia"
    },
    "IR": {
      "sigla": "IR",
      "nome": "Irã"
    },
    "IQ": {
      "sigla": "IQ",
      "nome": "Iraque"
    },
    "IE": {
      "sigla": "IE",
      "nome": "Irlanda"
    },
    "IS": {
      "sigla": "IS",
      "nome": "Islândia"
    },
    "IL": {
      "sigla": "IL",
      "nome": "Israel"
    },
    "IT": {
      "sigla": "IT",
      "nome": "Itália"
    },
    "JM": {
      "sigla": "JM",
      "nome": "Jamaica"
    },
    "JP": {
      "sigla": "JP",
      "nome": "Japão"
    },
    "JO": {
      "sigla": "JO",
      "nome": "Jordânia"
    },
    "KW": {
      "sigla": "KW",
      "nome": "Kuait"
    },
    "LA": {
      "sigla": "LA",
      "nome": "Laos"
    },
    "LS": {
      "sigla": "LS",
      "nome": "Lesoto"
    },
    "LV": {
      "sigla": "LV",
      "nome": "Letônia"
    },
    "LB": {
      "sigla": "LB",
      "nome": "Líbano"
    },
    "LR": {
      "sigla": "LR",
      "nome": "Libéria"
    },
    "LY": {
      "sigla": "LY",
      "nome": "Líbia"
    },
    "LI": {
      "sigla": "LI",
      "nome": "Liechtenstein"
    },
    "LT": {
      "sigla": "LT",
      "nome": "Lituânia"
    },
    "LU": {
      "sigla": "LU",
      "nome": "Luxemburgo"
    },
    "MO": {
      "sigla": "MO",
      "nome": "Macau"
    },
    "MK": {
      "sigla": "MK",
      "nome": "Macedônia, Antiga República Iugoslava"
    },
    "MG": {
      "sigla": "MG",
      "nome": "Madagascar"
    },
    "MY": {
      "sigla": "MY",
      "nome": "Malásia"
    },
    "MW": {
      "sigla": "MW",
      "nome": "Malawi"
    },
    "MV": {
      "sigla": "MV",
      "nome": "Maldivas"
    },
    "ML": {
      "sigla": "ML",
      "nome": "Mali"
    },
    "MT": {
      "sigla": "MT",
      "nome": "Malta"
    },
    "MA": {
      "sigla": "MA",
      "nome": "Marrocos"
    },
    "MQ": {
      "sigla": "MQ",
      "nome": "Martinica"
    },
    "MU": {
      "sigla": "MU",
      "nome": "Maurício"
    },
    "MR": {
      "sigla": "MR",
      "nome": "Mauritânia"
    },
    "YT": {
      "sigla": "YT",
      "nome": "Mayotte"
    },
    "MX": {
      "sigla": "MX",
      "nome": "México"
    },
    "MM": {
      "sigla": "MM",
      "nome": "República Democrática de Mianmá"
    },
    "FM": {
      "sigla": "FM",
      "nome": "Micronésia"
    },
    "MZ": {
      "sigla": "MZ",
      "nome": "Moçambique"
    },
    "MD": {
      "sigla": "MD",
      "nome": "Moldova"
    },
    "MC": {
      "sigla": "MC",
      "nome": "Mônaco"
    },
    "MN": {
      "sigla": "MN",
      "nome": "Mongólia"
    },
    "MS": {
      "sigla": "MS",
      "nome": "Montserrat"
    },
    "NA": {
      "sigla": "NA",
      "nome": "Namíbia"
    },
    "NR": {
      "sigla": "NR",
      "nome": "Nauru"
    },
    "NP": {
      "sigla": "NP",
      "nome": "Nepal"
    },
    "NI": {
      "sigla": "NI",
      "nome": "Nicarágua"
    },
    "NE": {
      "sigla": "NE",
      "nome": "Níger"
    },
    "NG": {
      "sigla": "NG",
      "nome": "Nigéria"
    },
    "NU": {
      "sigla": "NU",
      "nome": "Niue"
    },
    "NO": {
      "sigla": "NO",
      "nome": "Noruega"
    },
    "NC": {
      "sigla": "NC",
      "nome": "Nova Caledônia"
    },
    "NZ": {
      "sigla": "NZ",
      "nome": "Nova Zelândia"
    },
    "OM": {
      "sigla": "OM",
      "nome": "Omã"
    },
    "PW": {
      "sigla": "PW",
      "nome": "Palau"
    },
    "PA": {
      "sigla": "PA",
      "nome": "Panamá"
    },
    "PG": {
      "sigla": "PG",
      "nome": "Papua-Nova Guiné"
    },
    "PK": {
      "sigla": "PK",
      "nome": "Paquistão"
    },
    "PY": {
      "sigla": "PY",
      "nome": "Paraguai"
    },
    "PE": {
      "sigla": "PE",
      "nome": "Peru"
    },
    "PF": {
      "sigla": "PF",
      "nome": "Polinésia Francesa"
    },
    "PL": {
      "sigla": "PL",
      "nome": "Polônia"
    },
    "PR": {
      "sigla": "PR",
      "nome": "Porto Rico"
    },
    "PT": {
      "sigla": "PT",
      "nome": "Portugal"
    },
    "KE": {
      "sigla": "KE",
      "nome": "Quênia"
    },
    "KG": {
      "sigla": "KG",
      "nome": "Quirguistão"
    },
    "KI": {
      "sigla": "KI",
      "nome": "Quiribati"
    },
    "SY": {
      "sigla": "SY",
      "nome": "República Árabe da Síria"
    },
    "CF": {
      "sigla": "CF",
      "nome": "República Centro-Africana"
    },
    "CZ": {
      "sigla": "CZ",
      "nome": "República Tcheca"
    },
    "RE": {
      "sigla": "RE",
      "nome": "Reunião"
    },
    "RO": {
      "sigla": "RO",
      "nome": "Romênia"
    },
    "RW": {
      "sigla": "RW",
      "nome": "Ruanda"
    },
    "EH": {
      "sigla": "EH",
      "nome": "Saara Ocidental"
    },
    "PM": {
      "sigla": "PM",
      "nome": "Saint Pierre e Miquelon"
    },
    "AS": {
      "sigla": "AS",
      "nome": "Samoa Americana"
    },
    "WS": {
      "sigla": "WS",
      "nome": "Samoa Ocidental"
    },
    "SM": {
      "sigla": "SM",
      "nome": "San Marino"
    },
    "SH": {
      "sigla": "SH",
      "nome": "Santa Helena"
    },
    "LC": {
      "sigla": "LC",
      "nome": "Santa Lúcia"
    },
    "BL": {
      "sigla": "BL",
      "nome": "São Bartolomeu"
    },
    "KN": {
      "sigla": "KN",
      "nome": "São Cristóvão e Névis"
    },
    "MF": {
      "sigla": "MF",
      "nome": "São Martim"
    },
    "SX": {
      "sigla": "SX",
      "nome": "São Martinho"
    },
    "ST": {
      "sigla": "ST",
      "nome": "São Tomé e Príncipe"
    },
    "SN": {
      "sigla": "SN",
      "nome": "Senegal"
    },
    "SL": {
      "sigla": "SL",
      "nome": "Serra Leoa"
    },
    "CS": {
      "sigla": "CS",
      "nome": "Sérvia e Montenegro (antiga)"
    },
    "SC": {
      "sigla": "SC",
      "nome": "Seychelles"
    },
    "SO": {
      "sigla": "SO",
      "nome": "Somália"
    },
    "LK": {
      "sigla": "LK",
      "nome": "Sri Lanka"
    },
    "SZ": {
      "sigla": "SZ",
      "nome": "Suazilândia"
    },
    "SD": {
      "sigla": "SD",
      "nome": "Sudão"
    },
    "SE": {
      "sigla": "SE",
      "nome": "Suécia"
    },
    "CH": {
      "sigla": "CH",
      "nome": "Suíça"
    },
    "SR": {
      "sigla": "SR",
      "nome": "Suriname"
    },
    "SJ": {
      "sigla": "SJ",
      "nome": "Svalbard e Jan Mayen"
    },
    "TH": {
      "sigla": "TH",
      "nome": "Territórios do Sul da França"
    },
    "TW": {
      "sigla": "TW",
      "nome": "Taiwan"
    },
    "TJ": {
      "sigla": "TJ",
      "nome": "Tajiquistão"
    },
    "TZ": {
      "sigla": "TZ",
      "nome": "Tanzânia"
    },
    "TF": {
      "sigla": "TF",
      "nome": "Terras Austrais e Antárticas Francesas"
    },
    "IO": {
      "sigla": "IO",
      "nome": "Território Britânico do Oceano índico"
    },
    "PS": {
      "sigla": "PS",
      "nome": "Território Palestino Ocupado"
    },
    "TL": {
      "sigla": "TL",
      "nome": "Timor Leste"
    },
    "TG": {
      "sigla": "TG",
      "nome": "Togo"
    },
    "TK": {
      "sigla": "TK",
      "nome": "Toquelau"
    },
    "TO": {
      "sigla": "TO",
      "nome": "Tonga"
    },
    "TT": {
      "sigla": "TT",
      "nome": "Trinidad e Tobago"
    },
    "TN": {
      "sigla": "TN",
      "nome": "Tunísia"
    },
    "TM": {
      "sigla": "TM",
      "nome": "Turcomenistão"
    },
    "TR": {
      "sigla": "TR",
      "nome": "Turquia"
    },
    "TV": {
      "sigla": "TV",
      "nome": "Tuvalu"
    },
    "UA": {
      "sigla": "UA",
      "nome": "Ucrânia"
    },
    "UG": {
      "sigla": "UG",
      "nome": "Uganda"
    },
    "UY": {
      "sigla": "UY",
      "nome": "Uruguai"
    },
    "UZ": {
      "sigla": "UZ",
      "nome": "Uzbequistão"
    },
    "VU": {
      "sigla": "VU",
      "nome": "Vanuatu"
    },
    "VA": {
      "sigla": "VA",
      "nome": "Vaticano"
    },
    "VE": {
      "sigla": "VE",
      "nome": "Venezuela"
    },
    "VN": {
      "sigla": "VN",
      "nome": "Vietnã"
    },
    "ZM": {
      "sigla": "ZM",
      "nome": "Zâmbia"
    },
    "ZW": {
      "sigla": "ZW",
      "nome": "Zimbábue"
    }
  }


};

const getters = {
  nivel(state) {
    return state.nivel;
  },
  papeis(state) {
    return state.papeis;
  },
  _papeis(state) {
    return state._papeis;
  },
  estados(state) {
    return state.estados;
  },
  generos(state) {
    return state.generos;
  },
  paises(state) {
    return state.paises;
  },
};

export default {
  namespaced: true,
  state,
  getters
}
